import React, { Component } from 'react'
import { connect } from 'react-redux'
import {delay} from '../Animations/helper'
import GoalInfo from './GoalInfo'
import SubstitutionInfo from './SubstitutionInfo'

class InfoContainer extends Component {

    static propTypes = {
        currentEvent: React.PropTypes.number.isRequired
    }

    static defaultProps = {

    }

    constructor(props) {
        super(props);

        this.InfoQueue = new InfoQueue(() => this.onInfoQueueChange());
        this.state = {
            currentInfo: this.InfoQueue.CurrentInfo
        }
    }

    onInfoQueueChange() {
        delay(1000).then(() => this.setState({currentInfo: this.InfoQueue.CurrentInfo}))
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.currentEvent != this.props.currentEvent) {
            let frame = window.Json.game[nextProps.currentEvent-2];
            if(frame != null) {
                if(frame.G != null) {
                    this.InfoQueue.add(<GoalInfo id={'goal'} event={frame.G} key={'goal'} minute={frame.minute} onHide={(info) => this.InfoQueue.onHide(info)}/>);
                }

                if(frame.S != null) {
                    let key = `${frame.S.team}_${frame.S.in}_${frame.S.out}`;
                    this.InfoQueue.add(<SubstitutionInfo id={key} event={frame.S} key={key} onHide={(info) => this.InfoQueue.onHide(info)}/>);
                }
            }
        }
    }

    //<GoalInfo id={'goal'} event={{team: 1, player: 7}} key={'goal'} minute={15} onHide={(info) => this.InfoQueue.onHide(info)}/>

    render() {                      
        return (<div ref={(ref) => this.container = ref} className="infoContainer">
                    {this.state.currentInfo}
                </div>)
    }
}

export default InfoContainer

class InfoQueue {
    constructor(onChange) {
        this._infoCollection = [];
        this._onChange = onChange;
    }
    
    add(info) {
        this._infoCollection.push(info);
        this._onChange();
    }

    onHide(info) {
        this._infoCollection = this._infoCollection.filter(i => info.props.id !== i.props.id);
        this._onChange();
    }

    clean() {
        this._infoCollection = [];
        this._onChange();
    }

    get CurrentInfo() {
        if(this._infoCollection.length === 0)
            return null;
        
        return this._infoCollection[0];
    }
}




/** WEBPACK FOOTER **
 ** ./src/components/Info/InfoContainer.js
 **/